export enum Sizes {
  medium = 'medium',
  large = 'large',
  small = 'small',
}
